import React from "react";
import { Box, Flex, Text, HStack, Icon, Badge } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import { PiWalletFill } from "react-icons/pi";
import {
  selectWalletBalance,
  selectWalletInfo,
  selectWalletLoading,
} from "store/wallet/walletSelectors";

const WalletBalanceCard: React.FC = () => {
  const balance = useSelector(selectWalletBalance);
  const info = useSelector(selectWalletInfo);
  const loading = useSelector(selectWalletLoading);

  return (
    <Box
      bgGradient="linear(to-r, teal.500, blue.500)"
      borderRadius="md"
      p={6}
      //   color="white"
      boxShadow="sm"
      mb={6}
    >
      <Flex justify="space-between" align="flex-start">
        <HStack gap={3} align="center">
          <Box
            bg="whiteAlpha.200"
            borderRadius="full"
            p={3}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Icon as={PiWalletFill} boxSize={6} />
          </Box>
          <Box>
            <Text
              fontWeight="revert"
              fontSize="sm"
              textTransform="uppercase"
              opacity={0.8}
            >
              Wallet Balance
            </Text>
            <Text fontSize="3xl" fontWeight="bold">
              {loading ? "..." : `₹${balance.toFixed(2)}`}
            </Text>
            <HStack gap={2} mt={2}>
              <Badge
                variant="subtle"
                colorScheme={info?.hasWallet ? "green" : "red"}
                borderRadius="full"
                px={3}
              >
                {info?.hasWallet ? "Active Wallet" : "No Wallet"}
              </Badge>
              {/* {info?.isKyc && (
                <Badge
                  variant="solid"
                  colorScheme="green"
                  borderRadius="full"
                  px={3}
                >
                  Full KYC
                </Badge>
              )}
              {!info?.isKyc && info?.isMinKyc && (
                <Badge
                  variant="solid"
                  colorScheme="yellow"
                  borderRadius="full"
                  px={3}
                >
                  Min KYC
                </Badge>
              )} */}
            </HStack>
          </Box>
        </HStack>

        <Box textAlign="right">
          {/* <Text fontSize="xs" textTransform="uppercase" opacity={0.7}>
            Wallet ID
          </Text>
          <Text fontSize="sm" fontFamily="mono">
            {shortKey}
          </Text> */}
          {/* {info?.expiryTime && (
            <Tooltip content="Wallet token expiry (epoch ms)" hasArrow>
              <HStack gap={1} justify="flex-end" mt={2}>
                <Icon as={MdInfoOutline} boxSize={3} opacity={0.8} />
                <Text fontSize="xs" opacity={0.8}>
                  Expires: {info.expiryTime}
                </Text>
              </HStack>
            </Tooltip>
          )} */}
        </Box>
      </Flex>
    </Box>
  );
};

export default WalletBalanceCard;
